import { IEntityDto } from "./base";

export interface IOrderTaskLine extends IEntityDto {
  activityTypeId?: number;
  activityTypeAbbreviation?: string;
  activityTypeDescription?: string;
  activityTypeIsBillable?: boolean;
  activityTypeIsAtWork?: boolean;
  activityTypeIsPaid?: boolean;
  activityTypeType?: string;
  articleAbbreviation?: string;
  articleDescription?: string;
  articleGroupId?: number;
  articleGroupDescription?: string;
  articleHasInventoryManagement?: boolean;
  articleHasVariants?: boolean;
  articleId?: number;
  articleNumber?: string;
  articleVariantAbbreviation?: string;
  articleVariantId?: number;
  bearerDescription?: string;
  bearerId?: number;
  costTypeDescription?: string;
  costTypeId?: number;
  costTypeIndex?: number;
  copyFromLastLine?: boolean;
  createdById?: number;
  createdByName?: string;
  currencyAbbreviation?: string;
  departmentDescription?: string;
  departmentId?: number;
  description?: string;
  documentCount?: number;
  fiscalDateDays?: number;
  fiscalDateDaysFriendly?: string;
  locationAbbreviation?: string;
  locationId?: number;
  note?: string;
  orderNumber?: number;
  orderId?: number;
  orderTaskAbbreviation?: string;
  orderTaskDescription?: string;
  orderTaskId?: number;
  orderTaskIndex?: number;
  orderTaskLedgerId?: number;
  orderTaskLineType?: string;
  orderTaskLineTypeTranslated?: string;
  purposeDescription?: string;
  purposeId?: number;
  quantity?: number;
  resourceId?: number;
  resourceName?: string;
  responsibleId?: number;
  responsibleName?: string;
  salesPrice?: number;
  unitAbbreviation?: string;
  unitId?: number;
  amount?: number;
}
